import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Users } from 'lucide-react';
interface Slide2Props {
  onNavigate: (slide: number) => void;
  onBack: () => void;
}
export function Slide2({
  onNavigate,
  onBack
}: Slide2Props) {
  const menuItems = [{
    title: 'Treatment overview',
    slide: 4
  }, {
    title: 'Mode of action',
    slide: 12
  }, {
    title: 'Clinical use',
    slide: 13
  }, {
    title: 'Additional resources',
    slide: 7
  }];
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." onBack={onBack} data-id="element-111">
      <div className="w-full max-w-6xl mx-auto space-y-8" data-id="element-112">
        {/* Menu Section */}
        <div className="space-y-8" data-id="element-113">
          <h2 className="text-3xl font-bold text-primary text-center" data-id="element-114">
            Explore the dual-target approach
          </h2>
          <div className="grid grid-cols-2 gap-6" data-id="element-115">
            {menuItems.map((item, index) => <button key={index} onClick={() => onNavigate(item.slide)} className="bg-white border-2 border-primary rounded-xl p-6 hover:bg-primary hover:text-white transition-all duration-300 hover:shadow-2xl group" data-id="element-116">
                <div className="flex items-center justify-between" data-id="element-117">
                  <span className="text-lg font-semibold text-left" data-id="element-118">
                    {item.title}
                  </span>
                  <span className="text-3xl text-accent group-hover:text-highlight transition-colors" data-id="element-119">
                    →
                  </span>
                </div>
              </button>)}
          </div>
        </div>

        {/* Patient Profile - Now at Bottom */}
        <div className="inline-flex items-center gap-3 bg-highlight/20 border-l-4 border-accent rounded-lg px-4 py-3" data-id="element-120">
          <Users className="w-5 h-5 text-accent flex-shrink-0" data-id="element-121" />
          <p className="text-base text-primary leading-relaxed" data-id="element-122">
            <span className="font-bold" data-id="element-123">Patient profile:</span> Vabysmo
            <sup data-id="element-124">®</sup> is indicated for the treatment of nAMD, DMO, and RVO.
            <sup data-id="element-125">¹</sup>
          </p>
        </div>
      </div>
    </SlideLayout>;
}